module.exports = __webpack_public_path__ + "img/edit.0537c5b5.svg";